<template>
  <div class="q-pa-lg">
    <div class="row justify-between items-start">
      <h1>Реквизиты</h1>
      <q-btn
        v-if="$auth.check('root')"
        @click="newServiceProvider = true"
        color="primary"
        class="q-mt-sm"
      >
        Добавить
      </q-btn>
      <service-provider-create v-model="newServiceProvider" @save="updateServiceProviders()"/>
    </div>
    <service-providers ref="serviceProviders"/>
  </div>
</template>

<script>
  import ServiceProviders from 'components/ServiceProviders';
  import ServiceProviderCreate from '@/ServiceProviderCreate';
  import {
    QBtn
  } from 'quasar';

  export default {
    name: 'ServiceProvidersView',
    components: {
      QBtn,
      ServiceProviders,
      ServiceProviderCreate
    },
    data () {
      return {
        newServiceProvider: false
      };
    },
    computed: {
      updateServiceProviders() {
        return this.$refs.serviceProviders.updateProviders;
      }
    },
  };
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/views/ServiceProvidersView.vue